
var Mod = require('./mod/sufei-$');
var modConfig = require('./config/sufei-jquery');

// 统一version
var version = "0.1.0";
modConfig.version = version;
modConfig.style = "//g.alicdn.com/sd/sufei/" + version + "/" + modConfig.style;

new Mod(modConfig);